import { IPromise } from "angular";

export interface ChangeJournalLogItem {
  changeJournalRecord: ChangeJournalRecord;
  objectIdentifier: ChangeJournalObjectIdentifier;
  changeJournalObject?: ChangeJournalObject;
  relatedItems: ChangeJournalLogItem[];
}

export interface ChangeJournalObjectIdentifier {
  ObjectId: number;
  ObjectName: string;
}

export interface ChangeJournalViewItemResolver {
  (...args: any[]): IPromise<ChangeJournalObject[]>;
}

export interface ChangeJournalRecord
  extends ChangeJournalEntry,
    ChangeJournalObjectIdentifier {
  ChangeType: string;
  RequestTypeName: string;
  ResponseTypeName: string;
  CorrelationId: string;
}

export interface ChangeJournalObject {
  id: ChangeJournalObjectIdentifier;
  object: any;
}

export interface ChangeJournalEntry {
  Note: string;
}

export function ChangeJournalObjectIdentifierEqual(
  left: ChangeJournalObjectIdentifier,
  right: ChangeJournalObjectIdentifier
) {
  return (
    left &&
    right &&
    left.ObjectId &&
    right.ObjectId &&
    left.ObjectName &&
    right.ObjectName &&
    left.ObjectName.toLowerCase() === right.ObjectName.toLowerCase() &&
    left.ObjectId == right.ObjectId
  );
}
